//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../no/SelectNXObject.js";
import "../Motion/Motion.SelectMarker.js";
import "../no/SelectObject.js";
let d=[[[0,"ComponentType",1,0],[1,"MeasurementObject",0,"SelectNXObject",0],[0,"Name",1,0],[0,"ReferenceFrame",1,0],[1,"ReferenceMarker",0,"Motion.SelectMarker",0],[1,"RelativeMarker",0,"Motion.SelectMarker",0],[0,"Type",1,0]],[],[]];
SPLM.Motion.MotionSensorBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.MotionSensorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.MotionSensorBuilder.Component = Object.freeze({
    "LinearMagnitude" : "LinearMagnitude", "X" : "X", "Y" : "Y", "Z" : "Z", "AngularMagnitude" : "AngularMagnitude", "Rx" : "Rx", "Ry" : "Ry", "Rz" : "Rz"});

SPLM.Motion.MotionSensorBuilder.Reference = Object.freeze({
    "Absolute" : "Absolute", "Relative" : "Relative", "UserDefined" : "UserDefined"});

SPLM.Motion.MotionSensorBuilder.Types = Object.freeze({
    "Kinematic" : "Kinematic", "Displacement" : "Displacement", "Velocity" : "Velocity", "Acceleration" : "Acceleration", "Force" : "Force"});

export default SPLM;